import React from 'react';
var GroupButton = function (_a) {
    var className = _a.className, role = _a.role, children = _a.children, vertical = _a.vertical;
    var classNameResult = 'button-group ' + (vertical ? 'group-vertical ' : '') + ' ' + (className ? className : '');
    return (React.createElement("div", { className: classNameResult, role: role ? role : 'group' }, children));
};
export { GroupButton };
//# sourceMappingURL=GroupButton.js.map